import _ from "lodash";
import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import { ImageMain } from "../../../components/img/Img.Main";
import {
  findDebtCreditcard,
  findDebtInformalShortterm,
  findDebtShortterm,
  findDebtShorttermOther,
  findLongDebtCar,
  findLongDebtOther,
  findLongDebtPlace,
} from "../../../functions/futurePlan/futurechartFunction";
import { calDebtCreditCard, cn } from "../../../utils/useFunctions";
import { options_debt } from "../../balance/styles/Card";
import { formatPeriodTime } from "../../debt/component/VIDebtTable";
import {
  key_under_education,
  options_education_rank,
} from "../../education/functions/options";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderCardText,
  PdfHeaderText,
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { getNotPlan } from "../lib/pdf.lib";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11
} from "../styles/pdf.style";
import { useLegacyStore } from "../../../_store/legacyStore";

function PdfPageOverviewThree({
  page,
  futurePlanData,
  educationData,
  balanceData,
  debtData,
}) {
    const legacyData = useLegacyStore((state) => state.legacyData);
  
  const [isHasCollateral, setIsHasCollateral] = useState(false);

  const moneyNeed = useMemo(() => {
    const findData = futurePlanData?.cash_flow_items?.filter((item) => {
      return item?.remain_accumulate < 0 && item?.remain < 0;
    });
    return findData;
  }, []);

  // รวมยอดเงินต้นค้างชำระ
  const sumStartUnpaidAmount = () => {
    // บัตรเครดิต
    const sumCreditCard = () => {
      let result = 0;
      balanceData?.debt_short_list?.map((item) => {
        item?.credit_cards?.map((row) => {
          result += row?.unpaid_amount ? row?.unpaid_amount : 0;
        });
      });
      return result;
    };
    // เงินกู้ระยะสั้น
    const sumShortTerm = () => {
      let result = 0;
      balanceData?.debt_short_list?.map((item) => {
        item?.short_terms?.map((row) => {
          result += row?.unpaid_amount ? row?.unpaid_amount : 0;
        });
      });
      return result;
    };
    // เงินกู้นอกระบบ
    const sumInformalShortTerm = () => {
      let result = 0;
      balanceData?.debt_short_list?.map((item) => {
        item?.informal_short_terms?.map((row) => {
          result += row?.unpaid_amount ? row?.unpaid_amount : 0;
        });
      });
      return result;
    };
    // เงินกู้ระยะสั้นอื่นๆ
    const sumShortTermOther = () => {
      let result = 0;
      balanceData?.debt_short_list?.map((item) => {
        item?.short_term_others?.map((row) => {
          result += row?.unpaid_amount ? row?.unpaid_amount : 0;
        });
      });
      return result;
    };

    const finalResult =
      sumCreditCard() +
      sumShortTerm() +
      sumInformalShortTerm() +
      sumShortTermOther();

    return finalResult;
  };

  useEffect(() => {
    // if (firstRender) return;

    // ดูว่ามีรถคันไหนที่ผ่านเงื่อนไข
    // 1.มูลค่ารถยนต์ปัจจุบัน > หนี้รถยนต์ โดยที่ ต้องมากกว่า 100,000 บาทขึ้นไป
    // 2.ต้องมีหนี้ระยะสั้น
    // 3.ส่วนต่างข้องมูลค่ารถยนต์ปัจจุบัน - หนี้รถยนต์ ต้องมากกว่าจำนวนหนี้ระยะสั้น
    if (balanceData) {
      //---- เช็คว่ามีหนี้รพยะสั้นไหม ----//
      if (balanceData?.sum_debt_short > 0) {
        let carItems = [];

        for (const debt_long_item of balanceData?.debt_long_list) {
          if (debt_long_item?.options_debt_long === "debt_car") {
            carItems = [...carItems, ...debt_long_item?.debt_long_cars];
          }
        }

        //---- หารถที่มูลค่าปัจจุบันเยอะที่สุด ----//
        const mostCar = () => {
          let latestItemMax = { current_price: 0, unpaid_amount: 0 };
          for (const carItem of carItems) {
            if (carItem.current_price > latestItemMax.current_price) {
              latestItemMax = carItem;
            }
          }
          return latestItemMax;
        };

        //---- ส่วนต่างข้องมูลค่ารถยนต์ปัจจุบัน - หนี้รถยนต์ ----//
        const differenceCurrentPriceAndDebtCar =
          mostCar().current_price - mostCar().unpaid_amount;

        //========== เช็คว่ามีรถที่สามารถขายเพื่อล้างหนี้ได้ไหม ==========//
        if (
          differenceCurrentPriceAndDebtCar > 100000 &&
          differenceCurrentPriceAndDebtCar > sumStartUnpaidAmount()
        ) {
          setIsHasCollateral(true);
        } else {
          setIsHasCollateral(false);
        }
      }
    }
  }, [balanceData]);

  const merge_keys = useMemo(() => {
    let income_keys = futurePlanData?.cash_flow_keys?.filter(
      (cash_flow_key) => {
        return cash_flow_key.includes("income");
      }
    );
    let expenese_keys = futurePlanData?.cash_flow_keys?.filter(
      (cash_flow_key) => {
        return cash_flow_key.includes("expenese");
      }
    );
    let merge_income_keys = [
      // ...income_keys,
      "income_peryear",
      "remain_accumulate",
      "pension_peryear",
      "income_investment",
    ];
    let merge_expenese_keys = [
      // ...expenese_keys,
      "outcome_peryear",
      "out_come_stable",
    ];

    let merge_keys = [...merge_expenese_keys, ...merge_income_keys];
    // merge_keys = [];

    // หนี้ดอกลอย
    let debtShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm_other"
    )?.short_term_others;

    if (debtShortList?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtShorttermOther(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ีนอกระบบ
    let debtInformalShortterm = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_informal_shortterm"
    )?.informal_short_terms;

    if (debtInformalShortterm?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtInformalShortterm(balanceData, futurePlanData).title,
      ];
    }

    // เงินกู้ระยะสั้น
    let debtShorShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm"
    )?.short_terms;

    if (debtShorShortList?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtShortterm(balanceData, futurePlanData).title,
      ];
    }

    // บัตรเครดิต
    let debtCreditcard = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_creditcard"
    )?.credit_cards;

    if (debtCreditcard?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findDebtCreditcard(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ระยะยาว รถ
    let debtCar = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (debtCar?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findLongDebtCar(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ระยะยาว บ้าน
    let DebtPlace = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (DebtPlace?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findLongDebtPlace(balanceData, futurePlanData).title,
      ];
    }

    // หนี้ระยะยาว อื่นๆ
    let DebtOther = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_long_other"
    )?.debt_long_others;

    if (DebtOther?.length > 0) {
      merge_keys = [
        ...merge_keys,
        ...findLongDebtOther(balanceData, futurePlanData).title,
      ];
    }

    return merge_keys;
  }, [futurePlanData]);


  const dataDebt = useMemo(() => {
    let dataDebt = [];

    for (const merge_key of merge_keys) {
      let dataDebtItems = [];


      for (const cash_flow_item of futurePlanData?.cash_flow_items) {
        if (cash_flow_item[merge_key] !== undefined) {
          let amount = String(merge_key).startsWith("expenese")
            ? -cash_flow_item[merge_key]
            : cash_flow_item[merge_key];

          amount = Math.round(amount);
          if ([0, -0].includes(amount)) {
            amount = "";
          }

          dataDebtItems.push(amount);
        }
      }

      dataDebt.push(dataDebtItems);
    }

    dataDebt = dataDebt.filter((item) => item.length !== 0);

    // หนี้ดอกลอย
    let debtShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm_other"
    )?.short_term_others;

    if (debtShortList?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtShorttermOther(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ีนอกระบบ
    let debtInformalShortterm = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_informal_shortterm"
    )?.informal_short_terms;

    if (debtInformalShortterm?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtInformalShortterm(balanceData, futurePlanData).value,
      ];
    }

    // เงินกู้ระยะสั้น
    let debtShorShortList = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_shortterm"
    )?.short_terms;

    if (debtShorShortList?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtShortterm(balanceData, futurePlanData).value,
      ];
    }

    // บัตรเครดิต
    let debtCreditcard = balanceData?.debt_short_list?.find(
      (item) => item?.options_debt_short === "debt_creditcard"
    )?.credit_cards;

    if (debtCreditcard?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findDebtCreditcard(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ระยะยาว รถ
    let debtCar = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (debtCar?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findLongDebtCar(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ระยะยาว บ้าน
    let DebtPlace = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_car"
    )?.debt_long_cars;

    if (DebtPlace?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findLongDebtPlace(balanceData, futurePlanData).value,
      ];
    }

    // หนี้ระยะยาว อื่นๆ
    let DebtOther = balanceData?.debt_long_list?.find(
      (item) => item?.options_debt_long === "debt_long_other"
    )?.debt_long_others;

    if (DebtOther?.length > 0) {
      dataDebt = [
        ...dataDebt,
        ...findLongDebtOther(balanceData, futurePlanData).value,
      ];
    }

    return dataDebt;
  }, [futurePlanData]);

  const labels = useMemo(() => {
    let labels = [];
    for (const cash_flow_item of futurePlanData?.cash_flow_items) {
      labels.push(cash_flow_item.age);
    }
    return labels;
  }, [futurePlanData]);

  const debtShortItem = useMemo(() => {
    const newDebtShortItems = [];

    if (balanceData?.debt_short_list?.length > 0) {
      for (const debt_short_item of balanceData?.debt_short_list) {
        const keys = Object.keys(debt_short_item);
        for (const key of keys) {
          if (_.isArray(debt_short_item[key])) {
            for (const item of debt_short_item[key]) {
              let createItem = {
                title: "",
                unpaid_amount: item?.unpaid_amount,
                pay_permonth: item?.pay_permonth,
                interest: item?.interest,
                period: item?.period,
                period_time: "",
                type_payment: "",
                type_payment_ori: item?.type_payment,
                label: item?.creditor_name,
                status: options_debt.find(
                  (option) => option?.value === item?.status
                ),
                unit_interest: "ต่อปี",
                sort: 0,
              };

              // เครดิตการ์ด
              if (debt_short_item?.options_debt_short === "debt_creditcard") {
                const creditor = calDebtCreditCard(item);
                const period = creditor.creditor_items.length;
                const typePayment = !item?.type_payment
                  ? ""
                  : item?.type_payment === "pay_minimum"
                  ? "จ่ายขั้นต่ำ(รายเดือน)"
                  : item?.type_payment === "pay_full"
                  ? "จ่ายเต็มจำนวน"
                  : "จ่ายแบบระบุจำนวน(รายเดือน)";
                createItem.period = !item?.type_payment ? "" : period;
                createItem.period_time = !item?.type_payment
                  ? ""
                  : formatPeriodTime(period);
                createItem.type_payment = typePayment;
                createItem.title = "บัตรเครดิต";
                createItem.sort = 1;
              }

              if (debt_short_item?.options_debt_short === "debt_shortterm") {
                createItem.sort = 2;
                createItem.type_payment = "รายเดือน";
              } else if (
                debt_short_item?.options_debt_short ===
                "debt_informal_shortterm"
              ) {
                createItem.sort = 3;
                createItem.type_payment = "รายวัน";
                createItem.period = item?.number_of_days;
              } else if (
                debt_short_item?.options_debt_short === "debt_shortterm_other"
              ) {
                createItem.sort = 4;
                createItem.type_payment = "รายเดือน";
                createItem.unit_interest = "ต่อเดือน";
              }

              // เงินกู้ระยะสั้น, หนี้นอกระบบ, เงินกู้ระยะสั้นอื่นๆ
              if (
                [
                  "debt_shortterm",
                  "debt_informal_shortterm",
                  "debt_shortterm_other",
                ].includes(debt_short_item?.options_debt_short)
              ) {
                createItem.period_time = formatPeriodTime(item?.period);
              }

              if (
                debt_short_item?.options_debt_short ===
                "debt_informal_shortterm"
              ) {
                createItem.unpaid_amount = item?.start_amount;
              }
              newDebtShortItems.push(createItem);
            }
          }
        }
      }
    }

    const sortedItems = newDebtShortItems?.sort((a, b) => a.sort - b.sort);
    const totalPeriod = sortedItems?.reduce((prev, item) => {
      return prev + +item?.period;
    }, 0);
    const totalPerMonth = sortedItems?.reduce((prev, item) => {
      return prev + item?.pay_permonth;
    }, 0);
    return {
      totalPeriod,
      totalPerMonth,
    };
  }, [balanceData]);

  return (
    <div
      style={{
        backgroundImage: `url(/images/bg_pdf.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
      }}
      className={cn(STYLE_PAGE)}
    >
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText />
      <PdfCard className="space-y-2.5 ">
        <div className=" grid grid-cols-2 gap-2.5 ">
          {/* แผนอนาคต */}
          <PdfCardWhite className={"flex flex-col  "}>
            <PdfHeaderCardText
              title={`แผนอนาคต`}
              icon="/images/personal.svg"
              classNameIcon="w-[24px] h-[24px]"
              is_plan={futurePlanData?.cash_flow_items?.length}
            />

            <div className="w-full">
              <div className="  w-full rounded-lg h-full p-3 space-y-[6px]">
                <ImageMain
                  src="../images/cashflow.png"
                  className=" w-6 h-6 mx-auto"
                />
                {moneyNeed?.length > 0 &&
                  moneyNeed?.slice(0, 10)?.map((item, index) => {
                    return (
                      <div key={index} className=" text-[10px] ">
                        อายุ {item?.age} คุณต้องหารายรับเพิ่มอีก
                        <span className=" text-[10px] text-red-500 ">
                          {" "}
                          {`${numeral(Math.abs(item?.remain))?.format("0,0")} บาท`} 
                        </span>{" "}
                      </div>
                    );
                  })}
                {moneyNeed?.length > 10 && <div  className="h-4 w-fit text-xl font-medium text-center mx-auto [writing-mode:vertical-lr]">
                  ...
                </div>}
                <div className=" text-center text-mainblue text-[10px] ">
                  เพื่อทำให้แผนอนาคตของคุณเป็นไปตามเป้าหมาย
                  <div>
                    คุณต้องหารายรับเพิ่มอีก
                    <span className=" font-semibold">
                      {" "}
                      {numeral(
                        Math.abs(
                          moneyNeed?.reduce((acc, cur) => {
                            return acc + cur?.remain;
                          }, 0)
                        )
                      )?.format("0,0")}{" "}
                      บาท
                    </span>{" "}
                  </div>
                  (ดูรายละเอียดเพิ่มเติมที่แผนอนาคต)
                </div>
              </div>
            </div>
          </PdfCardWhite>

          {/* แผนศึกษาบุตร */}
          <PdfCardWhite className={"flex flex-col  "}>
            <PdfHeaderCardText
              title={`แผนศึกษาบุตร `}
              icon="/images/personal.svg"
              classNameIcon="w-[24px] h-[24px]"
              is_plan={educationData?.length}
            />
            <div className="flex flex-col">
              <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "mx-auto")}>
                บุตรทั้งหมด {educationData?.length} คน
              </div>
              <div
                className={cn(
                  STYLE_PDF_TEXT_MEDIUM_11,
                  "flex justify-between  "
                )}
              >
                <div> รวมค่าใช้จ่ายทั้งหมด </div>
                <div >
                  {numeral(
                    educationData?.reduce((prev, educationItem) => {
                      return prev + educationItem?.sum_total_education;
                    }, 0)
                  ).format("0,0")}{" "}
                  บาท
                </div>
              </div>
              <div
                className={cn(
                  STYLE_PDF_TEXT_MEDIUM_11,
                  "flex justify-between "
                )}
              >
                <div> รวมยอดทุนประกันของคุณ </div>
                <div >
                  {numeral(
                    educationData?.reduce((prev, educationItem) => {
                      return (
                        prev + educationItem?.education_items[0]?.sum_insurance
                      );
                    }, 0)
                  ).format("0,0")}{" "}
                  บาท
                </div>
              </div>
            </div>

            {educationData?.slice(0, 3)?.map((educationItem, index) => {
              return (
                <div key={index} className="flex flex-col mt-2">
                  <PdfLine className={"my-1 "} />
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    บุตรคนที่ {index + 1}: {educationItem?.name} อายุ{" "}
                    {educationItem?.age} สังกัด{" "}
                    {key_under_education?.[educationItem?.under_education]
                      ?.label || ""}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_11,
                      "flex justify-between font-normal "
                    )}
                  >
                    <div>รวมค่าใช้จ่ายเพื่อการศึกษา</div>
                    <div >
                      {numeral(educationItem?.sum_total_education).format(
                        "0,0"
                      )}{" "}
                      บาท
                    </div>
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_11,
                      "flex justify-between font-normal "
                    )}
                  >
                    <div>ยอดทุนประกันของคุณ</div>
                    <div >
                      {numeral(
                        educationItem?.education_items[0]?.sum_insurance
                      ).format("0,0")}{" "}
                      บาท
                    </div>
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_11,
                      "flex justify-between font-normal"
                    )}
                  >
                    <div>เป้าหมายการศึกษา</div>
                    <div >
                      {
                        options_education_rank?.find(
                          (thisRank) =>
                            thisRank?.value === educationItem?.target_education
                        )?.label
                      }
                    </div>
                  </div>
                </div>
              );
            })}

            {educationData?.length > 3 && (
              <div className={cn(STYLE_PDF_TEXT_MEDIUM_11, "mt-3 text-center")}>
                กรณีมีบุตรมากกว่า 3 คน ดูละเอียดบุตรคนอื่นๆ
                ที่หน้าแผนการศึกษาบุตร”
              </div>
            )}
          </PdfCardWhite>

          {/* แผนจัดการหนี้ */}
          <PdfCardWhite className={"flex flex-col  "}>
            <PdfHeaderCardText
              title={`แผนจัดการหนี้`}
              icon="/images/wealth_1.svg"
              classNameIcon="w-[24px] h-[24px]"
              is_plan={balanceData?.debt_propotion}
            />
            <div className={cn("flex flex-col")}>
              <div className="flex justify-center w-full">
                <img src="/images/good_pdf.svg" />
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, "flex flex-col mt-2")}
              >
                <div className={cn("flex justify-center")}>ยอดเยี่ยม</div>
                <div className="text-center">
                  คุณสามารถจัดการหนี้สินได้ดีเยี่ยม
                </div>
                {/* isHasCollateral */}
                {true ? (
                  <div className="flex flex-wrap justify-center">
                    <div className="text-center">
                      ผ่านการรวมหนี้สินเป็นก้อนเดียว 
                    </div>
                    <div className="text-center">/</div>
                    <div className="text-center">ผ่านการรีไฟแนนซ์รถยนต์</div>
                  </div>
                ) : (
                  <div className="flex">
                    <div className="text-center">
                      ผ่านการรวมหนี้สินเป็นก้อนเดียว
                    </div>
                  </div>
                )}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, "flex justify-between")}
              >
                <div className={cn("")}>หนี้เดิม</div>
                <div>
                  {numeral(debtData?.sum_unpaid_amount).format("0,0")} บาท
                </div>
              </div>

              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, "flex justify-between")}
              >
                <div className={cn("")}>หนี้ใหม่หลังปรับโครงสร้างหนี้</div>
                <div>
                  {numeral(debtData?.total_creditor_receive_af).format("0,0")}{" "}
                  บาท
                </div>
              </div>

              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, "flex justify-between")}
              >
                <div className={cn("")}>ระยะเวลาชำระ</div>
                <div>{debtData?.year} ปี</div>
              </div>

              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, "flex justify-between")}
              >
                <div className={cn("")}>เดือนละ</div>
                <div>
                  {numeral(debtData?.payPerMonth).format("0,0")} บาท
                </div>
              </div>
            </div>
          </PdfCardWhite>

          {/* แผนมรดก */}
          <PdfCardWhite className={"flex flex-col  "}>
            <PdfHeaderCardText
              title="แผนมรดก"
              icon="/images/revenue_1.svg"
              classNameIcon="w-[24px] h-[24px]"
              is_plan={!legacyData?.is_planed || false}
            />
            <div className={cn("flex flex-col")}>
              <div className="flex justify-center w-full">
                <img src="/images/good_pdf_2.svg" />
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, "flex flex-col mt-2")}
              >
                <div className="text-center">
                  ความมั่งคั่งจะส่งมอบสู่คนที่คุณรักและห่วงใย
                  แต่หากมีการเขียนพินัยกรรมสินทรัพย์ หนี้สิน สิทธิ หน้าที่
                  จะถูกส่งมอบให้กับคนที่คุณไว้วางใจได้อย่างเป็นระบบ
                </div>
              </div>
            </div>
          </PdfCardWhite>
        </div>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageOverviewThree;
